var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"rounded":"","depressed":"","text":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"size":"19","left":""}},[_vm._v("mdi-arrow-left")]),_vm._v(" Voltar")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }